import { N500 } from '@atlaskit/theme/colors';
import Tooltip from '@atlaskit/tooltip';
import { pluralize } from '@atlassian/mpac-utils';
import { differenceInDays } from 'date-fns';
import React from 'react';
import { DownloadIcon, InstallCountText, InstallCountWrapper } from "./InstallCount.styles";
const getPreinstalledMessage = (isPreinstalled, compatibleProducts) => {
  if (!isPreinstalled) return null;
  let tooltipMessage = '';
  if (compatibleProducts.length === 1) {
    tooltipMessage = "This app comes preinstalled in ".concat(compatibleProducts[0], " instances");
  } else if (compatibleProducts.length === 2) {
    tooltipMessage = "This app comes preinstalled in ".concat(compatibleProducts[0], " and ").concat(compatibleProducts[1], " instances");
  } else if (compatibleProducts.length >= 3) {
    tooltipMessage = "This app comes preinstalled in ".concat(compatibleProducts[0], ", ").concat(compatibleProducts[1], " and other products");
  }
  return {
    tooltipMessage,
    showDownloadIcon: false,
    installCountMessage: 'Preinstalled'
  };
};
const getNewAppMessage = createdAt => {
  if (createdAt == null) return null;
  const isNewApp = differenceInDays(new Date(), createdAt) <= 14;
  if (!isNewApp) return null;
  return {
    tooltipMessage: null,
    installCountMessage: 'New!',
    showDownloadIcon: false
  };
};
const getInstallCountMessage = (installCount, isPreinstalledInAnyHosting) => {
  if (!installCount || isPreinstalledInAnyHosting) return null;
  const countInLocaleString = installCount.toLocaleString();
  return {
    tooltipMessage: "Customers have installed this app in at least ".concat(countInLocaleString, " active ").concat(pluralize('instance', installCount)),
    installCountMessage: "".concat(countInLocaleString, " ").concat(pluralize('install', installCount)),
    showDownloadIcon: true
  };
};
const getDownloadCountMessage = (downloadCount, isPreinstalledInAnyHosting) => {
  if (!downloadCount || isPreinstalledInAnyHosting) return null;
  const countInLocaleString = downloadCount.toLocaleString();
  return {
    tooltipMessage: "Customers have downloaded this app in at least ".concat(countInLocaleString, " active ").concat(pluralize('instance', downloadCount)),
    installCountMessage: "".concat(countInLocaleString, " ").concat(pluralize('download', downloadCount)),
    showDownloadIcon: true
  };
};
const InstallCount = ({
  createdAt,
  distribution,
  compatibleProducts
}) => {
  const {
    installationCount,
    downloadCount,
    isPreinstalled,
    isPreinstalledInAnyHosting
  } = distribution || {};
  const {
    tooltipMessage,
    installCountMessage,
    showDownloadIcon
  } = getPreinstalledMessage(isPreinstalled, compatibleProducts) || getNewAppMessage(createdAt) || getInstallCountMessage(installationCount, isPreinstalledInAnyHosting) || getDownloadCountMessage(downloadCount, isPreinstalledInAnyHosting) || {};
  if (installCountMessage == null) return null;
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: tooltipMessage,
    position: "bottom"
  }, /*#__PURE__*/React.createElement(InstallCountWrapper, null, showDownloadIcon && /*#__PURE__*/React.createElement(DownloadIcon, {
    label: installCountMessage,
    primaryColor: N500,
    size: "small"
  }), /*#__PURE__*/React.createElement(InstallCountText, null, installCountMessage)));
};
export default InstallCount;